/**
 * 在这里定义的自定义指令，需要在config.js里面用directiveTransform定义好，否则构建会报错，影响其他功能
*/
import { ObjectDirective, DirectiveHook, App } from 'vue'
import { getAtModel, ACTION_TYPES } from '@/utils/atModel'

// loading指令的update钩子
const loadingUpdateHook: DirectiveHook = (el, bindings) => {
  // console.log('on loading update', el)
  if (bindings.value) {
    // 不要重复添加
    if (el.getElementsByClassName('elearning__loading').length) {
      return
    }
    el.style.position = 'relative'
    el.style.minHeight = '300px'
    // 最外层的容器
    const loadingEle = document.createElement('div')
    loadingEle.style.cssText = `
      position: absolute;
      z-index: 9999;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    `
    loadingEle.classList.add('elearning__loading')
    // loading-icon-wrapper
    const loadingIconWrapper = document.createElement('div')
    loadingIconWrapper.style.cssText = `
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      width: 41px;
      flex-wrap: wrap;
    `
    loadingIconWrapper.classList.add('elearning__loading-icon-wrapper')
    const loadingIconFactory = () => {
      // loading-icon
      const loadingIcon = document.createElement('div')
      loadingIcon.style.cssText = `
        width: 18px;
        height: 18px;
      `
      loadingIcon.classList.add('elearning__loading-icon')
      return loadingIcon
    }
    for (let i = 0; i < 4; i++) {
      const iconEle = loadingIconFactory()
      loadingIconWrapper.appendChild(iconEle)
    }
    loadingEle.appendChild(loadingIconWrapper)
    el.appendChild?.(loadingEle)
  } else {
    el.style.position = ''
    el.style.minHeight = 'auto'
    const ele = el.getElementsByClassName('elearning__loading')
    // console.log('on remove', ele)
    if (ele?.length) {
      el.removeChild?.(ele[0])
    }
  }
}

// 返回at指令的钩子
const getAtInitiationHook = (type: string) => {
  const hook: DirectiveHook = (el, bindings) => {
    const title = bindings.value
    // console.log('on at mounted', el, title)
    el.addEventListener('click', (e: Event) => {
      // console.log('on at', title, type)
      // e.stopPropagation()
      getAtModel().doAtEvent(title, type, e)
    })
  }
  return hook
}

const directives: Record<string, ObjectDirective> = {
  loading: {
    mounted: loadingUpdateHook,
    updated: loadingUpdateHook
  },
  'at-navigation': {
    mounted: getAtInitiationHook(ACTION_TYPES.navigation)
  },
  'at-action': {
    mounted: getAtInitiationHook(ACTION_TYPES.action)
  }
}

export const initVueDirective = (app: App) => {
  for (const key in directives) {
    app.directive(key, directives[key])
  }
}
